import { createContext } from "react"

const LocationContext = createContext({
  searchVisible: false,
})

export default LocationContext
